import {testIdProps} from '@github-ui/test-id-props'
import {Box, merge} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import type {PropsWithChildren} from 'react'
import {useListViewSelection} from '../ListView/SelectionContext'

export const defaultContainerStyles: BetterSystemStyleObject = {
  px: 1,
  gridArea: 'status',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  gap: 2,
}

export const ListItemLeadingContent = ({
  sx: externalSx,
  children,
}: PropsWithChildren<{sx?: BetterSystemStyleObject}>) => {
  const {isSelectable} = useListViewSelection()
  const baseSx = merge<BetterSystemStyleObject>(defaultContainerStyles, {
    pl: isSelectable ? undefined : '12px',
  })
  const containerSx = externalSx ? merge<BetterSystemStyleObject>(baseSx, externalSx) : baseSx

  return (
    <Box className="list-view-item-leadingcontent" {...testIdProps('list-view-item-leading-content')} sx={containerSx}>
      {children}
    </Box>
  )
}

try{ ListItemLeadingContent.displayName ||= 'ListItemLeadingContent' } catch {}